import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/blog/")({
  head: () =>
    buildHead({
      title: "LohaLink Journal — Scrap Metal & Steel Market Guides",
      description:
        "Practical guides on Indian scrap metal grading, GST and RCM rules, escrow trade safety, EPR credits and steel market movement — from the LohaLink desk.",
      canonical: "/blog",
    }),
  component: lazyRouteComponent(() => import("@/pages/Blog")),
});
